<script setup>
import CColorsFilter from "@/Components/CColorsFilter.vue";
import CPriceFilter from "@/Components/CPriceFilter.vue";
import CSubCategories from "@/Components/CSubCategories.vue";
import CStockFilter from "@/Components/CStockFilter.vue";

const props = defineProps({
    productList: {
        type: Object,
        default: () => ({})
    }
})
</script>

<template>
    <c-price-filter v-if="props.productList.canViewPrice" :min="props.productList.priceFilters.min" :max="props.productList.priceFilters.max"/>
    <c-sub-categories v-if="props.productList.category" :selectedCategory="props.productList.category"/>
    <c-colors-filter :color-groups="props.productList.colorGroups"/>
    <c-stock-filter v-if="props.productList.canViewStock"></c-stock-filter>
</template>